import React, { useCallback, useMemo, useReducer } from 'react';

import tabsConstants from './tabs.constants';
import TabsContext   from './tabs.context';
import tabsReducer   from './tabs.reducer';

/**
 * @type {React.FC}
 */

function TabsProvider({
  children,
  value = {},
}) {
  const [state, dispatch] = useReducer(tabsReducer, value);

  const changeTab = useCallback((component, active) => dispatch({
    type:      tabsConstants.CHANGE_TAB,
    component: component,
    active:    active,
  }), [dispatch]);

  const registerTabsComponent = useCallback((component) => dispatch({
    type:      tabsConstants.REGISTER_NEW_TABS_COMPONENT,
    component: component,
  }), [dispatch]);

  const context = useMemo(() => ({
    changeTab,
    registerTabsComponent,
    ...state,
  }), [changeTab, registerTabsComponent, state]);

  return (
    <TabsContext.Provider value={context}>
      {children}
    </TabsContext.Provider>
  );
}

export default TabsProvider;